/* eslint-disable no-unused-vars,class-methods-use-this,prefer-const,padding-line-between-statements,lines-between-class-members,no-var,vars-on-top,no-plusplus,eqeqeq,react/no-find-dom-node,no-underscore-dangle,prefer-destructuring */
/**
 * Created by harshal.patil on 3/10/2016.
 */
import React from 'react';
import ReactDOM from 'react-dom';

class AccessibilityUtils {
    ariaReplaceHTMLTagToText(text) {
        return text.replace(/(<[^>]*>)/g, ' ');
    }

    handleDomString(msg) {
        let accessibleMessageElement = document.getElementById(
            'accessibleAlertMessage',
        );
        if (accessibleMessageElement) {
            accessibleMessageElement.setAttribute('role', 'alert');
            accessibleMessageElement.parentNode.setAttribute(
                'aria-live',
                'assertive',
            );
            accessibleMessageElement.setAttribute('aria-live', 'assertive');
            accessibleMessageElement.innerHTML = '';
            let alertText = document.createTextNode(msg);
            accessibleMessageElement.appendChild(alertText);
            accessibleMessageElement.style.display = 'none';
            accessibleMessageElement.style.display = 'inline';
        }
    }

    removeAriaAttribute() {
        let accessibleMessageElement = document.getElementById(
            'accessibleAlertMessage',
        );
        if (accessibleMessageElement) {
            accessibleMessageElement.removeAttribute('role');
            accessibleMessageElement.parentNode.removeAttribute('aria-live');
            accessibleMessageElement.removeAttribute('aria-live');
            accessibleMessageElement.parentNode.removeAttribute('role');
            accessibleMessageElement.innerHTML = '';
            accessibleMessageElement.style.display = 'none';
        }
    }
    getGlobalNav(navData) {
        let globalNav = document.querySelectorAll('.global-nav a');
        let globalNavElements = [];
        let lang = navData.lang || 'en_US';
        if (globalNav) {
            for (var i = 0; i < globalNav.length; i++) {
                if (navData.globalNav.menu[i].isNotification) {
                    globalNav[i].setAttribute('id', 'notification-0');
                }
                if (
                    navData.globalNav.menu[i].actionName == 'showSupportPopUp'
                ) {
                    globalNav[i].setAttribute('id', 'support-0');
                }
            }
        }
    }
    handleMainNavigationItem(mainNav) {
        let navigationItem = ReactDOM.findDOMNode(
            mainNav.refs.navigationItem,
        ).querySelector('a[href]');
        navigationItem.addEventListener('keydown', (event) => {
            if (event.shiftKey == true && event.keyCode == 9) {
                mainNav._hideSubMenu(event);
            }
        });
    }
    handleSubNavigationItem(subNav) {
        let submenuItems = ReactDOM.findDOMNode(
            subNav.refs.subMenu,
        ).querySelectorAll('a[href]');
        let submenuItemsArray = [];
        for (var i = 0; i < submenuItems.length; i++) {
            submenuItemsArray.push(submenuItems[i]);
        }
        if (submenuItemsArray.length > 0) {
            let lastSubMenu = submenuItemsArray[submenuItemsArray.length - 1];
            lastSubMenu.addEventListener('keydown', (event) => {
                if (event.shiftKey == false && event.keyCode == 9) {
                    setTimeout(() => {
                        subNav._hideSubMenu(event);
                    }, 10);
                }
            });
        }
    }
    handleMainNavOnEsc(mainNavRef) {
        let mainMenuNav = ReactDOM.findDOMNode(mainNavRef.refs.navigationItem);
        mainMenuNav.addEventListener('keydown', (event) => {
            if (event.keyCode == 27) {
                mainNavRef._hideSubMenu(event);
            }
        });
    }
    handleSubMenuOnEsc(subMenuRef) {
        let subMenuNav = ReactDOM.findDOMNode(subMenuRef.refs.subMenu);
        subMenuNav.addEventListener('keydown', (event) => {
            if (event.keyCode == 27) {
                subMenuRef._hideSubMenu(event);
            }
        });
    }
    handleFocusRestriction(refElement, focusableElements, isSetFirstFocus) {
        let elements = ReactDOM.findDOMNode(refElement).querySelectorAll(
            focusableElements,
        );
        let allEnableElements = [];
        let firstElement;
        for (var i = 0; i < elements.length; i++) {
            let formElement = elements[i];
            if (
                formElement &&
                formElement.getAttribute('type') != 'hidden' &&
                formElement.getAttribute('tabindex') != '-1'
            ) {
                allEnableElements.push(formElement);
            }
        }
        if (allEnableElements.length > 0) {
            firstElement = allEnableElements[0];
            if (isSetFirstFocus) {
                allEnableElements[0].focus();
            }
            firstElement.addEventListener('keydown', (event) => {
                if (event.shiftKey == true && event.keyCode == 9) {
                    firstElement.focus();
                    event.preventDefault();
                }
            });
            let lastElement = allEnableElements[allEnableElements.length - 1];
            lastElement.addEventListener('keydown', (event) => {
                if (event.shiftKey == false && event.keyCode == 9) {
                    event.preventDefault();
                }
            });
        }
    }
}
export default new AccessibilityUtils();
